import { Sparkles } from "lucide-react";

export const GlassActionCard = ({ card, onAction }) => (
  <div className="glass glass-dark w-[86%] rounded-[24px] p-3" data-testid="ai-suggested-card">
    <div className="flex items-center gap-1.5 text-[11px] font-semibold text-[#A79DE2]" data-testid="ai-suggested-label">
      <Sparkles size={12} aria-hidden />
      Suggested by AI
    </div>
    <div className="mt-2 flex gap-3">
      <img src={card.image} alt="" className="h-16 w-12 shrink-0 rounded-[12px] object-cover" />
      <div className="min-w-0">
        <p className="text-[14px] font-semibold leading-tight text-white">{card.title}</p>
        <p className="mt-0.5 text-[12px] text-white/65">{card.meta}</p>
        <p className="mt-1 text-[11px] text-white/60">{card.reason}</p>
      </div>
    </div>
    <button type="button" onClick={onAction} data-testid="ai-card-view-moment-button" className="mt-3 h-9 w-full rounded-full bg-white/90 text-[13px] font-semibold text-[#14151B] transition-colors hover:bg-white">
      {card.cta}
    </button>
  </div>
);
